import React from 'react';
import { Auth, Amplify } from 'aws-amplify';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../../Redux/Actions/userActions';

import * as MESSAGES from '../../Lib/Messages';
import Notification from '../UI_Library/Notification/Notification';
import InputError from '../UI_Library/FormElements/InputError';
import Validator from '../../Lib/Validator';
import classes from './Auth.module.css';
import AuthPageWrapper from './AuthPageWrapper/AuthPageWrapper';
import Button from 'Components/UI_Library/FormElements/Button';
import { withRouter } from 'Lib/withRouter';
import queryString from 'query-string';
import awsExports from '../../aws-exports';

class UserActivation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            errors: {},
            isError: false,
            errorMessage: null,
            isFederated: false,
            isShowForm: true,
            isDisabled: false,
        };

        Amplify.configure(awsExports);

        this.state = { ...this.getInitialState(), ...this.state };

        const mss = this.props.location.state || {};
        if (mss.messages) {
            this.setState({
                errorMessage: mss.messages,
                isError: mss.isError || false,
            });
            const { pathname } = this.props.location;
            this.props.history(pathname, { replace: true });
        }
    }

    getInitialState = () => ({
        user: {
            email: '',
            code: '',
        },
    });

    componentDidMount() {
        const paymentsView = localStorage.getItem('paymentsView');
        const billsView = localStorage.getItem('billsView');
        const email = localStorage.getItem('UserEmail');
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem('paymentsView', paymentsView);
        localStorage.setItem('billsView', billsView);

        const { location } = this.props;
        const parsed = queryString.parse(location.search);
        if (parsed.userId) {
            const { user } = this.state;
            user.Id = parsed.userId;
            this.setState({ isDisabled: true, user });
            if (!parsed.re_active) {
                this.setState({
                    errorMessage: MESSAGES.SUCCESS_USER_SIGNUP,
                    isError: false,
                    loading: false,
                });
            }
            if (parsed.federated) {
                this.setState({
                    isFederated: true,
                });
            }
        } else if (email) {
            const { user } = this.state;
            user.email = email;
            this.setState({ isDisabled: true, user });
        }

        this.codeInput.focus();
        window.addEventListener('keypress', this.onEnter, false);
    }

    onEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (this.state.loading) return;
            this.handleActivate(e);
        }
    };

    componentWillUnmount = () => {
        window.removeEventListener('keypress', this.onEnter, false);
    };

    clearForm = () => {
        this.setState(this.getInitialState());
    };

    handleChange = (event) => {
        const {
            target: { name, value },
        } = event;
        const { user, errors } = this.state;
        user[name] = value;
        this.setState(user);
        if (errors[name]) {
            delete errors[name];
        }
    };

    handleSendCode = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!this.isValidation(true)) {
            return false;
        }

        this.setState({ loading: true });

        const { user } = this.state;
        Auth.resendSignUp(user.Id || user.email)
            .then(() => {
                this.setState({
                    errorMessage: MESSAGES.SUCCESS_RESEND_CODE,
                    isError: false,
                    loading: false,
                });
            })
            .catch((err) => {
                this.setState({ loading: false });
                if (err.message) {
                    this.setState({ errorMessage: err.message, isError: true });
                }
            });

        return true;
    };

    handleActivate = async (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!this.isValidation()) {
            return false;
        }

        this.setState({ loading: true });

        const { user, isFederated } = this.state;
        const { history } = this.props;
        Auth.confirmSignUp(user.Id || user.email, user.code, {
            forceAliasCreation: true,
        })
            .then(() => {
                this.clearForm();
                this.setState({
                    errorMessage: isFederated
                        ? MESSAGES.SUCCESS_ACTIVATE_ACCOUNT_FEDERATED
                        : MESSAGES.SUCCESS_ACTIVATE_ACCOUNT,
                    isError: false,
                    loading: false,
                    isShowForm: false,
                });
                if (isFederated) {
                    setTimeout(() => {
                        Auth.federatedSignIn({
                            provider: 'LoginWithXero',
                            customState: JSON.stringify({ type: 'xero_oidc' }),
                        });
                    }, 4000);
                } else {
                    setTimeout(() => {
                        history('/signin');
                    }, 4000);
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                if (err.message) {
                    if (err.message === 'User cannot be confirmed. Current status is CONFIRMED') {
                        this.setState({
                            errorMessage: 'This email is already confirmed. Redirecting you to sign in.',
                            isError: false,
                        });
                        setTimeout(() => {
                            history('/signin');
                        }, 4000);
                    } else {
                        this.setState({ errorMessage: err.message, isError: true });
                    }
                }
            });

        return true;
    };

    isValidation(isResend) {
        this.setState({ errors: {}, errorMessage: '' });

        const errors = {};
        let isError = false;
        const { user } = this.state;
        const validator = new Validator();

        if (!user.Id && !validator.required(user.email)) {
            errors.email = MESSAGES.ERROR_REQUIRED;
            isError = true;
        } else if (!user.Id && !validator.email(user.email)) {
            errors.email = MESSAGES.ERROR_EMAIL;
            isError = true;
        }

        if (!validator.required(user.code) && !isResend) {
            errors.code = MESSAGES.ERROR_REQUIRED;
            isError = true;
        }

        if (!window.navigator.onLine) {
            this.setState({
                errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION,
                isError: true,
            });
            isError = true;
        }

        if (isError) {
            this.setState({ errors });
            return false;
        }

        return true;
    }

    render() {
        const { user, loading, isShowForm, errors, isError, errorMessage, isDisabled } = this.state;
        return (
            <AuthPageWrapper>
                <div className={classes.form}>
                    <h2 className={classes.title}>Confirm your email</h2>
                    <div className="card-body active-form" style={{ minWidth: '270px' }}>
                        <Notification
                            isError={isError}
                            message={errorMessage}
                            handleCloseMsg={() => {
                                this.setState({ errorMessage: '' });
                            }}
                        />
                        {isShowForm ? (
                            <form method="POST">
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        {user.Id ? null : (
                                            <div className={`form-group${errors.email ? ' form-error' : ''}`}>
                                                <label>Email</label>
                                                <input
                                                    name="email"
                                                    type="text"
                                                    disabled={isDisabled}
                                                    className="form-control"
                                                    placeholder="example@company.com"
                                                    value={user.email}
                                                    onChange={this.handleChange}
                                                />
                                                <InputError error={errors.email} />
                                            </div>
                                        )}

                                        <div
                                            className={`form-group${errors.code ? ' form-error' : ''}`}
                                            style={{ position: 'relative' }}
                                        >
                                            <div className={classes.resendCode}>
                                                <label>Verification code</label>
                                                <Button type="ghost" text="Resend code" onClick={this.handleSendCode} />
                                            </div>
                                            <input
                                                name="code"
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="123456"
                                                value={user.code}
                                                onChange={this.handleChange}
                                                ref={(inputEl) => {
                                                    this.codeInput = inputEl;
                                                }}
                                            />
                                            <InputError error={errors.code} />
                                        </div>
                                        <Button
                                            type="primary"
                                            onClick={this.handleActivate}
                                            disabled={loading}
                                            loading={loading}
                                            text="Confirm"
                                        />
                                    </div>
                                </div>
                            </form>
                        ) : null}
                    </div>
                </div>
            </AuthPageWrapper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserActivation));
